<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Max Groups</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" v-model="max_groups" type="text" placeholder="Max bid group" :class="{ 'is-danger': errors.max_groups }">
                    <span class="icon is-left">
                        <i class="fas fa-gavel"></i>
                    </span>
                    <p v-if="errors.max_groups" class="help is-danger">{{ errors.max_groups[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            max_groups: {
                get() {
                    return this.$store.getters.getNewPricePlan.max_groups
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'max_groups', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/MaxGroupInput.vue